import React from 'react'
import { Fade, Fab, Tooltip } from '@mui/material'
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded'

function ScrollToTopFab({
  bottom = 24,
  right = 24,
  zIndex = 1303,
  threshold = 240,
  hidden = false,
}) {
  const [isVisible, setIsVisible] = React.useState(false)

  React.useEffect(() => {
    if (hidden) {
      setIsVisible(false)
      return undefined
    }

    const handleScroll = () => {
      if (typeof window === 'undefined') return
      const nextVisible = window.scrollY > threshold
      setIsVisible((current) => (current === nextVisible ? current : nextVisible))
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [hidden, threshold])

  const scrollToTop = React.useCallback(() => {
    if (typeof window === 'undefined') return

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [])

  return (
    <Fade in={!hidden && isVisible}>
      <div
        style={{
          position: 'fixed',
          right,
          bottom,
          zIndex,
          pointerEvents: !hidden && isVisible ? 'auto' : 'none',
        }}
      >
        <Tooltip title="Scroll to top">
          <Fab
            color="primary"
            size="medium"
            aria-label="Scroll to top"
            onClick={scrollToTop}
            sx={{
              boxShadow: '0 10px 25px rgba(15, 23, 42, 0.22)',
              '&:hover': {
                boxShadow: '0 14px 30px rgba(15, 23, 42, 0.28)',
              },
            }}
          >
            <KeyboardArrowUpRoundedIcon />
          </Fab>
        </Tooltip>
      </div>
    </Fade>
  )
}

export default ScrollToTopFab

